import { global } from '../constants';

export const data = {
  banner: {
    background: global.banner + 'metals-banner.jpg',
    title: 'Precious Metals',
    crumb: 'Industries / Precious Metals',
  },
  whychoosus: {
    img: global.banner + 'metals-2.jpg',
    title: 'Secure & Trusted Precious Metals Logistics Experts',
    subtitle: 'WHY CHOOSE US FOR PRECIOUS METALS',
    description:
      'We provide world-class logistics for gold, silver, platinum, and other precious metals. With advanced security protocols, specialized packaging, and a global network of partners, we ensure your assets are transported safely, discreetly, and on time—every time.',
    projects: '45+',
    specifications: [
      'Advanced multi-layered security for high-value shipments.',
      'End-to-end tracking and monitoring for complete transparency.',
      'Specialized tamper-proof packaging to safeguard against theft or damage.',
      'Fully insured deliveries with strict international compliance.',
      'Decades of expertise in handling large-scale corporate consignments.',
      'Trusted by leading financial institutions, refiners, and private clients worldwide.',
    ],
  },
  services: {
    title: 'Logistics Partner to the Precious Metals Elite',
    subtitle: 'WHO WE SERVE',
    description:
      'We proudly serve a diverse network of global leaders who entrust us with their most valuable assets. Our clients rely on us for absolute discretion, unmatched security, and seamless delivery.',
    services: [
      {
        icon: global.icons + 'bank.png',
        serial: '01',
        title: 'Banks & Financial Institutions',
        description:
          'Our aim is to optimize and improve your supply chain so that we can give you the best service.',
      },
      {
        icon: global.icons + 'oil.png',
        serial: '02',
        title: 'Jewelers & Refiners',
        description:
          'From raw materials to finished products, we ensure jewelers and refiners receive their shipments safely and on time..',
      },
      {
        icon: global.icons + 'mining-cart.png',
        serial: '03',
        title: 'Mining Companies',
        description:
          'We handle the complex logistics of moving newly mined metals from remote locations to global markets safely and efficiently.',
      },
      {
        icon: global.icons + 'money.png',
        serial: '04',
        title: 'Precious Metal Exchanges',
        description:
          'Supporting major exchanges with secure transport and custody solutions. ',
      },
      {
        icon: global.icons + 'building.png',
        serial: '05',
        title: 'Investment Firms',
        description:
          'We support investment companies with insured transport and long-term vaulting solutions for precious metals portfolios.',
      },
      {
        icon: global.icons + 'individual.png',
        serial: '06',
        title: 'High-Net-Worth Individuals',
        description:
          'Discreet, personalized logistics for private clients who demand absolute confidentiality and security.',
      },
    ],
  },

  estimation: {
    title: 'TAILORED EXECUTION',
    subtitle: 'Built Around Your Business Needs',
    description:
      "Whether you're shipping from a boutique or managing global inventory, our services integrate seamlessly with your supply chain for efficient, secure movement of valuable goods.",
    solutions: [
      {
        serial: '01',
        icon: global.eicons + 'pic1.png',
        title: 'Integrated Workflows',
        description:
          'From shipping documents to customs procedures, our solutions fit smoothly into your existing logistics and supply chain processes.',
      },
      {
        serial: '02',
        icon: global.eicons + 'pic2.png',
        title: 'Global Vault Access',
        description:
          'We provide access to strategically located high-security vaults and bonded warehouses across key diamond and jewelry hubs worldwide.',
      },
      {
        serial: '03',
        icon: global.eicons + 'pic3.png',
        title: ' Discreet Handling',
        description:
          'We operate with utmost confidentiality — packaging, documentation, and delivery all reflect the need for privacy and professionalism.',
      },
    ],
  },

  blogs: {
    title: 'OUR STANDARDS',
    subtitle: 'Ensuring Excellence Through Every Detail',
    description:
      'From security to compliance, our approach is shaped by precision and discipline. We don’t just move valuables — we protect trust, reputation, and legal integrity at every point in the journey.',
    blogs: [
      {
        image: global.blog + 'card-1.png',
        icon: '🛡️',
        title: 'Uncompromising Security Protocols',
        description:
          'Every shipment is guarded by strict security measures — from discreet collection to armed transit and restricted-access vaults. Our clients trust us to protect the irreplaceable.',
      },
      {
        image: global.blog + 'card-2.jpeg',
        icon: '📄',
        title: 'Flawless Compliance Management',
        description:
          'We navigate international regulations with precision — ensuring each shipment meets export controls, valuation requirements, and customs documentation standards.',
      },
    ],
  },
};
